import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32120c3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trip-route" }
const _hoisted_2 = { class: "trip-route__section" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "trip-route__radio" }
const _hoisted_6 = { class: "trip-route__section" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "trip-route__radio" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TripType = _resolveComponent("TripType")!
  const _component_BaseRadio = _resolveComponent("BaseRadio")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, {
    errors: _ctx.v$.booking.$errors,
    disabled: _ctx.disabled
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", null, [
          _createVNode(_component_TripType)
        ]),
        _createElementVNode("section", _hoisted_2, [
          (_ctx.modeOfTravel === _ctx.ModeOfTravelEnum.FlyAndSail || _ctx.modeOfTravel === _ctx.ModeOfTravelEnum.SailAndFly)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "Outward journey:"))
            : _createCommentVNode("", true),
          (_ctx.modeOfTravel !== _ctx.ModeOfTravelEnum.FlyAndSail && _ctx.modeOfTravel !== _ctx.ModeOfTravelEnum.SailAndFly)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_4, "From:"))
            : _createCommentVNode("", true),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outwardDestinations, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.code
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_component_BaseRadio, {
                    name: option.code,
                    id: option.code,
                    key: option.code,
                    label: _ctx.destinationNames[option.code],
                    value: option.code,
                    modelValue: _ctx.from,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.from) = $event))
                  }, null, 8, ["name", "id", "label", "value", "modelValue"]))
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("section", _hoisted_6, [
          (_ctx.modeOfTravel === _ctx.ModeOfTravelEnum.FlyAndSail || _ctx.modeOfTravel === _ctx.ModeOfTravelEnum.SailAndFly)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, "Return journey:"))
            : _createCommentVNode("", true),
          (_ctx.modeOfTravel !== _ctx.ModeOfTravelEnum.FlyAndSail && _ctx.modeOfTravel !== _ctx.ModeOfTravelEnum.SailAndFly)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_8, "To:"))
            : _createCommentVNode("", true),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.returnDestinations, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.code
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(), _createBlock(_component_BaseRadio, {
                    name: 'return' + option.code,
                    id: 'return' + option.code,
                    key: 'return' + option.code,
                    label: _ctx.destinationNames[option.code],
                    value: option.code,
                    disabled: _ctx.disableRoute(option.code),
                    modelValue: _ctx.to,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.to) = $event))
                  }, null, 8, ["name", "id", "label", "value", "disabled", "modelValue"]))
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["errors", "disabled"]))
}